import routes, { routeBits, getRouterPaths } from './routes';

export { routeBits, getRouterPaths };
export default routes;
